export const TOGGLE = {
  desktop: { top: 35, right: 40, size: 48 }, // used above 480px
  mobile: { top: 20, right: 20, size: 40 }, // used at 480px and below
};

export const CONTROL_GAP = 12;
